import { useQuery } from "@tanstack/react-query";
import { expenseService } from "./expense.services";
import { expenseKeys } from "./expense.keys";
import { GetExpensesParams } from "./expense.types";

export const useGetExpenses = (params?: GetExpensesParams) => {
  return useQuery({
    queryKey: expenseKeys.list(params),
    queryFn: () => expenseService.getExpenses(params),
  });
};

export const useGetExpenseById = (expenseId: string) => {
  return useQuery({
    queryKey: expenseKeys.detail(expenseId),
    queryFn: () => expenseService.getExpenseById(expenseId),
    enabled: !!expenseId,
  });
};

export const useGetExpenseStats = () => {
  return useQuery({
    queryKey: expenseKeys.stats(),
    queryFn: () => expenseService.getExpenseStats(),
  });
};

export const useGetExpenseInvoices = (params?: GetExpensesParams) => {
  return useQuery({
    queryKey: [...expenseKeys.all, "invoices", params],
    queryFn: () => expenseService.getExpenseInvoices(params),
  });
}; 